import { render, staticRenderFns } from "./Timeline_magister.vue?vue&type=template&id=3ddab30c"
import script from "./Timeline_magister.vue?vue&type=script&lang=js"
export * from "./Timeline_magister.vue?vue&type=script&lang=js"
import style0 from "./Timeline_magister.vue?vue&type=style&index=0&id=3ddab30c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports